import { styled as materialStyled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { theme } from '../../../theme/theme';

interface ICustomTextField {
  height?: number;
  width?: number;
}

const CustomTextField = materialStyled(TextField)<ICustomTextField>(
  ({ error, multiline, height = 40, disabled, width }) => ({
    '& .MuiInputBase-root': {
      width: width || '100%',
      height: !multiline && height,
      borderRadius: '8px',
      borderColor: theme.palette.shades.grayBorder,
      padding: '8px',
      gap: '8px',
      marginBottom: '10px',
      backgroundColor: disabled ? theme.palette.shades.whiteBorder2 : 'inherit',
    },
    '& .MuiOutlinedInput-input': {
      padding: 0,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1px solid ${error ? '#DF0C3D' : theme.palette.shades.grayBorder} !important`,
      },
      '&:hover fieldset': {
        border: `1px solid ${error ? '#DF0C3D' : theme.palette.shades.grayBorder} !important`,
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${error ? '#DF0C3D' : theme.palette.shades.blueBorder} 
        !important`,
      },
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Inter',
      fontSize: '15px',
      color: theme.palette.shades.placeHolder,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.shades.disabled,
      },
      '&::placeholder': {
        color: theme.palette.shades.placeHolder,
        fontFamily: 'Inter',
        fontSize: '15px',
      },
    },
  }),
);

export default CustomTextField;
